import React from 'react';
import './RightForYou.css';

const RightForYou = () => {
  const forYou = [
    'Salon and medspa owners who want clarity',
    'Growing or multi-location businesses',
    'Teams tired of spreadsheet chaos'
  ];

  const notForYou = [
    'DIY reporting',
    'One-size-fits-all dashboards',
    'Owners who don\'t want to change decisions'
  ];

  return (
    <section id="right-for-you" className="right-for-you-section">
      <div className="container">
        <h2 className="section-title">Is Jajoga right for you?</h2>

        <div className="columns">
          <div className="column is-for">
            <div className="column-header">
              <div className="header-icon">✓</div>
              <h3>Jajoga is for:</h3>
            </div>
            <ul className="list">
              {forYou.map((item, index) => (
                <li key={index}>
                  <span className="check-icon">✔</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="column is-not-for">
            <div className="column-header">
              <div className="header-icon">✖</div>
              <h3>Jajoga is not for:</h3>
            </div>
            <ul className="list">
              {notForYou.map((item, index) => (
                <li key={index}>
                  <span className="x-icon">✖</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RightForYou;
